// extracted by mini-css-extract-plugin
module.exports = {"container":"_24k8uzW4v6xHhscmgikiGO"};